import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_wp6dvttf8e: FaireBrandEntity = {
  token: "b_wp6dvttf8e",
  type: "brand",
  name: "Fresa Creative",
  avatarUrl:
    "https://cdn.faire.com/fastly/13e35396760fcff18c2c32a56039e361d894c543171288227a05d25442bbb0ba.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b708367cd09998426388b3efc47eae0deaa9aa0cc5114b5065c922323f5bfbb8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/13e35396760fcff18c2c32a56039e361d894c543171288227a05d25442bbb0ba.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b708367cd09998426388b3efc47eae0deaa9aa0cc5114b5065c922323f5bfbb8.jpeg",
  location: "Chicago, IL, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 12,
  isInsider: true,
  description:
    "Hello, new Fresas! \n\nThank you so much for your interest, if you are interested in purchasing, please remember to use our Faire Direct link: https://fresacreative.faire.com and feel free to send a message if you'd like to try a sample before placing a full order. \n\n**\n\nFresa Creative is a Latina-owned candle brand inspired by garden fresh scents from my Mexican + Midwest roots. Fresa uniquely highlights fresh fragrance - each candle will transport you to the Midwest gardens from my childhood and connect you to your own memories of childhood summers being outside. \n\nFresa Creative was named as a reclamation of the Mexican slang used to negatively describe a “fresa” or strawberry—a stuck-up, spoiled girl. It’s a nickname my parents lovingly gave me, one my mom still uses to this day; a metaphor for my life as a Mexican woman being raised in the the rural Midwest - constantly in-between two opposing perspectives between cultures, customs, religion, and gender norms. \n\nFresa candles are an outlet for storytelling, individuality, and connection. They celebrate the beauty of embracing the fragmented pieces of life to create something whole - a living, breathing expression of creativity and purpose. With every candle, I hope to give moment of light and positivity for anyone that needs it.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:13.883Z",
    importedBy: "entity-db-cli",
  },
};
